import React from 'react';

import { Option } from '../option';
import { Select } from '../select';
import { SelectOption, SingleOption, isSingleOption } from '../select-types';
import useSelectInputV2 from './select-input-v2.controller';

const ID = 'select-input-v2';
export interface SelectInputV2Props<T> {
    id?: string;
    label?: React.ReactNode;
    helpMessage?: React.ReactNode;
    placeholder?: string;

    options: SelectOption<T>[];
    onSelect?: (option: SingleOption<T> | null) => void;
    value?: string | null;
    searchValueOverwrite?: string;

    onSearch?: (value: string) => void;
    onScrollToBottom?: () => void;

    required?: boolean;
    disabled?: boolean;

    isClearable?: boolean;
    isLoading?: boolean;

    className?: string;

    onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    hideLabel?: boolean;
}

export const SelectInputV2 = <T,>(props: SelectInputV2Props<T>) => {
    const viewProps = useSelectInputV2<T>(props);

    return (
        <div
            id={ID}
            className={'form-group w-100 ' + props.className}>
            {!props.hideLabel && (
                <label className='text-primary'>
                    {props.required ? <span className='text-danger me-1'>&#9679;</span> : <></>} {props.label}
                    {props.helpMessage && (
                        <>
                            <br />
                            <small className='form-text text-muted'>{props.helpMessage}</small>
                        </>
                    )}
                </label>
            )}
            <Select
                id={props.id || ID}
                onSelect={viewProps.onSelect}
                placeholder={props.placeholder}
                value={viewProps.value}
                disabled={props.disabled}
                onChange={viewProps.onSearch}
                isClearable={props.isClearable}
                onScrollToBottom={props.onScrollToBottom}
                onFocus={props.onFocus}
                onBlur={props.onBlur}>
                {viewProps.searchResultOptions &&
                    viewProps.searchResultOptions.map((option) => {
                        if (isSingleOption(option)) {
                            return (
                                <Option
                                    key={option.value}
                                    {...option}
                                />
                            );
                        }
                        return (
                            <>
                                {option.label}
                                {option.options.map((option: SingleOption<T>) => (
                                    <Option
                                        key={option.value}
                                        {...option}
                                    />
                                ))}
                            </>
                        );
                    })}
            </Select>
        </div>
    );
};

export default SelectInputV2;
